export type Tone = 'success' | 'warning' | 'error' | 'info' | 'neutral';

/** The theme colour behind each tone (neutral = grey text colour) */
export const toneColor = (tone: Tone) => `var(--mui-palette-${tone === 'neutral' ? 'text-secondary' : tone + '-main'})`;
